export const MENU = Object.freeze({
    // GENERAL
    NOTIFICATION_MENU: "notification",
    COMPLAINT_MENU: "complaint",
    COMPLAINT_CATEGORY_MENU: "complaint_category",
    COMPLAINT_SUB_MENU: "complaint_sub",
    PRIORITY_MENU: "priority",
    LIST_SHIFT_MENU: "list_shift",
    DISTRIBUTOR_MENU: "distributor",
    PRINCIPAL_MENU: "principal",
    PIC_PRINCIPAL_MENU: "pic_principal",
    CONTACT_MENU: "contact",
    CHANNEL_MENU: "channel",
    NS_CODE_MENU: "ns_code",
    CS_ONLINE_MENU: "cs_online",
    CS_OFFLINE_MENU: "cs_offline",
    CS_LEVEL_MENU: "cs_level",
    CSO_MENU: "cso",
    FORCE_LOG_OUT_DESKTOP_MENU: "force_log_out_desktop",
    TOTAL_CS_ONLINE_MANAGER_MENU: "total_cs_online.manager",
    TOTAL_CS_ONLINE_LEAD_MENU: "total_cs_online.lead",
    TICKET_RELATED_MENU: "ticket.tiket_lain",
    // PROFILE SETTINGS
    PROFILE_USER_MENU: "profile.profile.profile",
    PROFILE_CHANGE_PASSWORD_MENU: "profile.profile.profile.change_password",
    PROFILE_CHANGE_PROFILE_MENU: "profile.profile.profile.change_profile",
    // DASHBOARD
    DASHBOARD_MENU: "dashboard.dashboard.dashboard",
    DASHBOARD_PRINCIPAL_MENU: "dashboard.dashboard.principal",
    DASHBOARD_MANAGER_MENU: "dashboard.dashboard.manager",
    DASHBOARD_LEAD_MENU: "dashboard.dashboard.lead",
    DASHBOARD_CSO_MENU: "dashboard.dashboard.cso",
    // TICKET LIST ALL
    TICKET_LIST_ALL_MENU: "daftar_tiket.daftar_tiket.semua_tiket",
    TICKET_LIST_ALL_OPEN_MENU: "daftar_tiket.daftar_tiket.semua_tiket.open",
    // TICKET LIST ALL DETAIL
    TICKET_LIST_ALL_NOTE_MENU: "daftar_tiket.daftar_tiket.semua_tiket.note",
    TICKET_LIST_ALL_ATTACHMENT_MENU: "daftar_tiket.daftar_tiket.semua_tiket.lampiran_file",
    TICKET_LIST_ALL_ISSUE_MENU: "daftar_tiket.daftar_tiket.semua_tiket.keluhan",
    TICKET_LIST_ALL_ESCALATE_MENU: "daftar_tiket.daftar_tiket.semua_tiket.eskalasi",
    TICKET_LIST_ALL_CLOSE_MENU: "daftar_tiket.daftar_tiket.semua_tiket.tutup_tiket",
    TICKET_LIST_ALL_URL_LINK_MENU: "daftar_tiket.daftar_tiket.semua_tiket.url_link",
    TICKET_LIST_ALL_RELEASE_VERSION_MENU: "daftar_tiket.daftar_tiket.semua_tiket.versi_rilis",
    TICKET_LIST_ALL_REDMINE_MENU: "daftar_tiket.daftar_tiket.semua_tiket.no_redmine",
    TICKET_LIST_ALL_CUSTOMER_NAME_MENU: "daftar_tiket.daftar_tiket.semua_tiket.nama_pelanggan",
    TICKET_LIST_ALL_ROOT_CAUSE_MENU: "daftar_tiket.daftar_tiket.semua_tiket.root_cause",
    TICKET_LIST_ALL_ISSUE_CATEGORY_MENU: "daftar_tiket.daftar_tiket.semua_tiket.kategori",
    TICKET_LIST_ALL_CONTACT_MENU: "daftar_tiket.daftar_tiket.semua_tiket.kontak",
    TICKET_LIST_ALL_REOPEN_MENU: "daftar_tiket.daftar_tiket.semua_tiket.ubah_tiket",
    // TICKET LIST MEMBER
    TICKET_LIST_MEMBER_MENU: "daftar_tiket.daftar_tiket.tiket_anggota",
    // TICKET LIST NEW
    TICKET_LIST_NEW_MENU: "daftar_tiket.daftar_tiket.tiket_masuk",
    TICKET_LIST_NEW_MANAGER_MENU: "daftar_tiket.daftar_tiket.tiket_masuk_manager",
    TICKET_LIST_NEW_MANAGER_ASSIGN_MENU: "daftar_tiket.daftar_tiket.tiket_masuk_manager.assign",
    TICKET_LIST_NEW_CSO_MENU: "daftar_tiket.daftar_tiket.tiket_masuk_cso",
    TICKET_LIST_NEW_CSO_GRAB_MENU: "daftar_tiket.daftar_tiket.tiket_masuk_cso.grab",
    TICKET_LIST_NEW_ESCALATED_MENU: "daftar_tiket.daftar_tiket.tiket_masuk.eskalasi",
    TICKET_LIST_NEW_REASSIGN_MENU: "daftar_tiket.daftar_tiket.tiket_masuk.reassign",
    TICKET_LIST_NEW_ASSIGN_MENU: "daftar_tiket.daftar_tiket.tiket_masuk.assign",
    // TICKET LIST SOLUTION
    TICKET_LIST_SOLUTION_MENU: "daftar_tiket.daftar_tiket.solusi",
    // TICKET LIST SOLUTION DETAIL
    TICKET_LIST_SOLUTION_RELEASE_VERSION_MENU: "daftar_tiket.daftar_tiket.solusi.versi_rilis",
    TICKET_LIST_SOLUTION_REDMINE_MENU: "daftar_tiket.daftar_tiket.solusi.no_redmine",
    // CREATE TICKET
    TICKET_CREATE_MENU: "daftar_tiket.daftar_tiket.buat_tiket",
    TICKET_CREATE_ATTACHMENT_MENU: "daftar_tiket.daftar_tiket.buat_tiket.lampiran_file",
    // CONTACT
    CONTACT_LIST_MENU: "kontak.kontak.kontak",
    // PRINCIPAL TICKET REPORT
    PRINCIPAL_TICKET_REPORT_MENU: "laporan.laporan.laporan_tiket_principal",
    PRINCIPAL_TICKET_REPORT_EXPORT_FILE_MENU: "laporan.laporan.laporan_tiket_principal.tombol_export",
    PRINCIPAL_TICKET_REPORT_SEND_FILE_MENU: "laporan.laporan.laporan_tiket_principal.tombol_kirim_file",
    // EXPORT TICKET
    EXPORT_TICKET_MENU: "laporan.laporan.ekspor_tiket",
    EXPORT_TICKET_PROFILE_MENU: "laporan.laporan.ekspor_tiket.profile",
    // SETTINGS
    SETTING_CS_AGENT_MENU: "pengaturan.pengaturan.cs_agen",
    SETTING_CS_AGENT_SHIFT_MENU: "pengaturan.pengaturan.cs_agen.shift",
    SETTING_PARAMETER_MENU: "pengaturan.pengaturan.parameter",
    SETTING_CHATBOT_FLOW_MENU: "pengaturan.pengaturan.flow_chatbot",
    SETTING_KMS_MENU: "pengaturan.pengaturan.kms",
    SETTING_NEWS_FEED_MENU: "pengaturan.pengaturan.berita",
    SETTING_JOB_PROCESS_MENU: "pengaturan.pengaturan.proses_kerja",
    SETTING_LOGIN_HISTORY_MENU: "pengaturan.pengaturan.riwayat_kerja",
    SETTING_QUEUE_MENU: "pengaturan.pengaturan.antrian",
    SETTING_SESSION_MENU: "pengaturan.pengaturan.pengguna_online",
    SETTING_ISSUE_CATEGORY_MENU: "pengaturan.pengaturan.kategori_masalah",
    SETTING_COMMISSION_MENU: "pengaturan.pengaturan.skema_komisi",
    SETTING_CALL_HISTORY_MENU: "pengaturan.pengaturan.riwayat_panggilan",
    // MASTER DATA
    MASTER_DATA_ROLE_MENU: "master_data.master_data.role",
    MASTER_DATA_DATA_GROUP_MENU: "master_data.master_data.data_group",
    MASTER_DATA_USER_MENU: "master_data.master_data.user",
    MASTER_DATA_DATA_CUSTOMER_MENU: "master_data.master_data.data_customer",
    MASTER_DATA_SHIFT_MENU: "master_data.master_data.shift",
    MASTER_DATA_REMARK_MENU: "master_data.master_data.remark",
    MASTER_DATA_IMPORT_MENU: "master_data.master_data.import",
    // GROCHAT WEBSOCKET
    TICKET_LIST_ALL_CHAT_MENU: "daftar_tiket.daftar_tiket.semua_tiket.chat",
    TICKET_LIST_ALL_CHAT_HISTORY_MENU: "daftar_tiket.daftar_tiket.semua_tiket.chat_history",
    TICKET_LIST_SOLUTION_CHAT_HISTORY_MENU: "daftar_tiket.daftar_tiket.solusi.chat_history",
})